import { InternalId } from '@edgebox/data-definition-kit';
import { ClientSiteEntity, ISyncCoreApi } from '@edgebox/sync-core-rest-client';
import { onlyRegularSites } from '../../../siteKind.utils';

const ITEMS_PER_PAGE = 100;
const MAX_PAGES = 20;

/**
 * The site a project's work is attached to: a crawl, a monitoring run and every other task group
 * name a site as their target. The site itself is handed back, so a caller references the entity it
 * was given rather than building a reference out of an id it carried around.
 *
 * The platform's own source of terms belongs to the project as well, and Sync Core refuses it as a
 * target, so it is skipped here — a run that picked it would fail at the server with nothing on the
 * screen to explain it.
 */
export async function resolveProjectSite({
  api,
  projectId,
}: {
  api: ISyncCoreApi;
  projectId?: InternalId;
}): Promise<ClientSiteEntity | undefined> {
  for (let currentPage = 0; currentPage < MAX_PAGES; currentPage += 1) {
    const siteList = await api.billing.sites.list(undefined, { page: currentPage, itemsPerPage: ITEMS_PER_PAGE });
    const listed = siteList.items || [];

    const site = onlyRegularSites(listed).find((entry) => {
      if (!projectId) {
        return true;
      }

      return entry.project?.getId?.() === projectId;
    });

    if (site?.id) {
      return site;
    }

    // Whether another page follows is decided by what the server sent, not by what is left after the
    // platform's own source of terms was taken out.
    if (listed.length < ITEMS_PER_PAGE) {
      break;
    }
  }

  return undefined;
}
